import { Box, styled, Typography } from '@mui/material';

export const BeneficiaryContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(4),
})) as typeof Box;

export const AllocationLabelStyled = styled(Typography)(({ theme }) => ({
  margin: 'auto 0',
  textAlign: 'right',
  color: theme.palette.grey[400],
}));

export const NarrowBoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '40%',
});

export const WiderBoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '60%',
});
